import { Link } from "react-router-dom";
import { MessageCircle, CheckCircle2, Phone } from "lucide-react";
import { buildWhatsAppUrl } from "@/lib/utm";

export default function Thanks() {
  const wa = buildWhatsAppUrl("5218116289267", "Hola Eclipse, acabo de enviar mi solicitud de cotizacion. Quiero agilizar por aqui.");
  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center px-6 py-16">
      <CheckCircle2 className="w-20 h-20 text-green-400 mb-6" strokeWidth={1.5} />
      <h1 className="text-4xl md:text-5xl font-black mb-4 text-center section-title">Gracias por tu solicitud</h1>
      <p className="text-lg text-white/70 max-w-xl text-center mb-8">
        Un experto de Eclipse se pondrá en contacto contigo en menos de 24 horas.
        Si prefieres, acelera tu cotización por WhatsApp.
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <a href={wa} target="_blank" rel="noreferrer" className="btn-wa px-6 py-3 rounded-lg inline-flex items-center gap-2">
          <MessageCircle className="w-5 h-5" /> Hablar por WhatsApp
        </a>
        <a href="tel:+528189899822" className="btn-outline-light px-6 py-3 rounded-lg inline-flex items-center gap-2">
          <Phone className="w-5 h-5" /> Llamar ahora
        </a>
        <Link to="/" className="px-6 py-3 rounded-lg text-white/70 hover:text-white inline-flex items-center">
          Volver al sitio
        </Link>
      </div>
    </div>
  );
}
